module.exports = __webpack_public_path__ + "img/scene8.88a45dbf.png";